import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationRouteSegments } from 'src/app/shared/enums/enums';
import { BusinessSettingsService } from '../../business-settings.service/business-settings.service';

@Component({
  selector: 'app-select-store-type',
  templateUrl: './select-store-type.component.html',
  styleUrls: ['./select-store-type.component.scss']
})
export class SelectStoreTypeComponent implements OnInit {

  constructor(
    private businessSettingsService: BusinessSettingsService,
    private router: Router,
    private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.businessSettingsService.hideTabsValue = true;
  }

  selectStore(isOnlineStore: boolean) {
    this.router.navigate([ApplicationRouteSegments.addStore], { relativeTo: this.route.parent, state: { isOnlineStore } });
  }
}
